import styles from './DescriptiveSwithField.css'
import SwitchField from 'components/Fields/ReduxForm/SwitchField'
import {Field} from 'redux-form'

class DescriptiveSwitchField extends React.Component {
  render () {
    return (<div className={`${styles['form-group']} row`}>
      <div className='col-lg-9 col-md-9 col-sm-6'>
        <div className={styles.label}>{this.props.label}</div>
        <div className={styles.sublabel}>{this.props.sublabel}</div>
      </div>
      <div className='col-lg-3 col-md-3 col-sm-6'>
        <div className={styles['field-right']}>
          <Field
            component={SwitchField}
            name={this.props.name}
            type='checkbox'
          />
        </div>
      </div>
    </div>)
  }
}

DescriptiveSwitchField.propTypes = {
  label: React.PropTypes.string,
  sublabel: React.PropTypes.string,
  name: React.PropTypes.string
  // we using value from redux form so no props of value here
}

export default DescriptiveSwitchField



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DescriptiveSwitchField/DescriptiveSwitchField.js